import { render } from "./assign-data.vue?vue&type=template&id=283e30da&scoped=true"
import script from "./assign-data.vue?vue&type=script&lang=js"
export * from "./assign-data.vue?vue&type=script&lang=js"

import "./assign-data.vue?vue&type=style&index=0&id=283e30da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283e30da"]])

export default __exports__